import Login from "../auth/signin/Login";
// import Signup from "../auth/signup/Signup";
import { FaTractor } from "react-icons/fa";
import Trips from "../pages/trips/Trips";
import TripForm from "../pages/trips/TripForm.jsx";

export const routes = [
 
  {
    path: "/login",
    element: <Login />,
    name: "Login",
    layout: "auth",
  },
  {
    path: "/trips",
    element: <Trips />,
    name: "Trips",
    layout: "app",
    icon: FaTractor,
    roles: [0, 1],
  },
   {
    path: "/trips-add",
    element: <TripForm />,
    // name: "Trips",
    layout: "app",
    // icon: FaTractor,
    // roles: [0, 1],
  },

];

export default routes;
